import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading({ isModal = false }: { isModal?: boolean }) {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={1} isModal={isModal} />

      <Container>
        <LeftSection forceFullWidth={isModal}>
          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 h-16" />
            </FormLayout>
          </CardContainer>

          <CardContainer>
            <SectionHeadingSkeleton withIcon={false} />
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12" />
              <InputSkeleton className="col-span-12 h-16" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
